import React from 'react';
import { Brain, Code, TrendingUp, Heart, Briefcase, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { jobCategories } from '../data/mock';

const iconMap = {
  Brain: Brain,
  Code: Code,
  TrendingUp: TrendingUp,
  Heart: Heart,
  Briefcase: Briefcase,
};

const CategorySection = () => {
  return (
    <section className="py-16 px-8 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2 text-center">Find Your Perfect Role</h2>
        <p className="text-gray-500 text-center mb-10">Browse opportunities across top industries</p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {jobCategories.map((category) => {
            const IconComponent = iconMap[category.icon];
            return (
              <Link
                key={category.id}
                to={`/roles?category=${category.id}`}
                className="group bg-white rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-100 hover:border-indigo-100"
              >
                <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:bg-indigo-100 transition-colors">
                  <IconComponent className="w-6 h-6 text-indigo-600" />
                </div>
                <h3 className="font-medium text-gray-900 text-sm group-hover:text-indigo-600 transition-colors">
                  {category.name}
                </h3>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
